var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21617 16.5C4.1172 16.4998 4.01935 16.4791 3.92884 16.439C3.83833 16.399 3.75715 16.3405 3.69044 16.2674C3.62253 16.1949 3.57071 16.1088 3.53838 16.0149C3.50605 15.9209 3.49393 15.8212 3.50283 15.7222L3.6776 13.8L11.7511 5.72713L14.2742 8.25017L6.20281 16.3223L4.28108 16.4971C4.2595 16.4991 4.23784 16.5001 4.21617 16.5ZM14.7778 7.7457L12.2555 5.22266L13.7684 3.70927C13.8347 3.64293 13.9134 3.5903 14 3.55439C14.0866 3.51848 14.1794 3.5 14.2731 3.5C14.3669 3.5 14.4597 3.51848 14.5463 3.55439C14.6329 3.5903 14.7116 3.64293 14.7778 3.70927L16.2908 5.22266C16.3571 5.28893 16.4097 5.36763 16.4456 5.45425C16.4815 5.54087 16.5 5.63372 16.5 5.72749C16.5 5.82125 16.4815 5.9141 16.4456 6.00073C16.4097 6.08735 16.3571 6.16604 16.2908 6.23231L14.7785 7.74499L14.7778 7.7457Z",
    fill: "#FCFAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.14362793c03d16cc7393a6225a6d6bdc.svg";
export { ForwardRef as ReactComponent };